export default class NotFoundError extends Error {
    notFoundError = true;
    resourceType;
    constructor(resourceType, ...args) {
        super(`Resource ${resourceType} not found.`, ...args);
        this.resourceType = resourceType;
    }
}
